[
  { "name": "Panama", "flag": "🇵🇦", "country_code": "507" },
  { "name": "Costa Rica", "flag": "🇨🇷", "country_code": "506" },
  { "name": "United States", "flag": "🇺🇸", "country_code": "1" },
  { "name": "Afghanistan", "flag": "🇦🇫", "country_code": "93" },
  { "name": "Åland Islands", "flag": "🇦🇽", "country_code": "358" },
  { "name": "Albania", "flag": "🇦🇱", "country_code": "355" },
  { "name": "Algeria", "flag": "🇩🇿", "country_code": "213" },
  { "name": "American Samoa", "flag": "🇦🇸", "country_code": "1684" },
  { "name": "Andorra", "flag": "🇦🇩", "country_code": "376" },
  { "name": "Angola", "flag": "🇦🇴", "country_code": "244" },
  { "name": "Anguilla", "flag": "🇦🇮", "country_code": "1264" },
  { "name": "Antarctica", "flag": "🇦🇶", "country_code": "672" },
  { "name": "Antigua and Barbuda", "flag": "🇦🇬", "country_code": "1268" },
  { "name": "Argentina", "flag": "🇦🇷", "country_code": "54" },
  { "name": "Armenia", "flag": "🇦🇲", "country_code": "374" },
  { "name": "Aruba", "flag": "🇦🇼", "country_code": "297" },
  { "name": "Australia", "flag": "🇦🇺", "country_code": "61" },
  { "name": "Austria", "flag": "🇦🇹", "country_code": "43" },
  { "name": "Azerbaijan", "flag": "🇦🇿", "country_code": "994" },
  { "name": "Bahamas", "flag": "🇧🇸", "country_code": "1242" },
  { "name": "Bahrain", "flag": "🇧🇭", "country_code": "973" },
  { "name": "Bangladesh", "flag": "🇧🇩", "country_code": "880" },
  { "name": "Barbados", "flag": "🇧🇧", "country_code": "1246" },
  { "name": "Belarus", "flag": "🇧🇾", "country_code": "375" },
  { "name": "Belgium", "flag": "🇧🇪", "country_code": "32" },
  { "name": "Belize", "flag": "🇧🇿", "country_code": "501" },
  { "name": "Benin", "flag": "🇧🇯", "country_code": "229" },
  { "name": "Bermuda", "flag": "🇧🇲", "country_code": "1441" },
  { "name": "Bhutan", "flag": "🇧🇹", "country_code": "975" },
  {
    "name": "Bolivia, Plurinational State of bolivia",
    "flag": "🇧🇴",
    "country_code": "591"
  },
  { "name": "Bosnia and Herzegovina", "flag": "🇧🇦", "country_code": "387" },
  { "name": "Botswana", "flag": "🇧🇼", "country_code": "267" },
  { "name": "Bouvet Island", "flag": "🇧🇻", "country_code": "47" },
  { "name": "Brazil", "flag": "🇧🇷", "country_code": "55" },
  {
    "name": "British Indian Ocean Territory",
    "flag": "🇮🇴",
    "country_code": "246"
  },
  { "name": "Brunei Darussalam", "flag": "🇧🇳", "country_code": "673" },
  { "name": "Bulgaria", "flag": "🇧🇬", "country_code": "359" },
  { "name": "Burkina Faso", "flag": "🇧🇫", "country_code": "226" },
  { "name": "Burundi", "flag": "🇧🇮", "country_code": "257" },
  { "name": "Cambodia", "flag": "🇰🇭", "country_code": "855" },
  { "name": "Cameroon", "flag": "🇨🇲", "country_code": "237" },
  { "name": "Canada", "flag": "🇨🇦", "country_code": "1" },
  { "name": "Cape Verde", "flag": "🇨🇻", "country_code": "238" },
  { "name": "Cayman Islands", "flag": "🇰🇾", "country_code": "345" },
  { "name": "Central African Republic", "flag": "🇨🇫", "country_code": "236" },
  { "name": "Chad", "flag": "🇹🇩", "country_code": "235" },
  { "name": "Chile", "flag": "🇨🇱", "country_code": "56" },
  { "name": "China", "flag": "🇨🇳", "country_code": "86" },
  { "name": "Christmas Island", "flag": "🇨🇽", "country_code": "61" },
  { "name": "Cocos (Keeling) Islands", "flag": "🇨🇨", "country_code": "61" },
  { "name": "Colombia", "flag": "🇨🇴", "country_code": "57" },
  { "name": "Comoros", "flag": "🇰🇲", "country_code": "269" },
  { "name": "Congo", "flag": "🇨🇬", "country_code": "242" },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "flag": "🇨🇩",
    "country_code": "243"
  },
  { "name": "Cook Islands", "flag": "🇨🇰", "country_code": "682" },
  { "name": "Cote d'Ivoire", "flag": "🇨🇮", "country_code": "225" },
  { "name": "Croatia", "flag": "🇭🇷", "country_code": "385" },
  { "name": "Cuba", "flag": "🇨🇺", "country_code": "53" },
  { "name": "Cyprus", "flag": "🇨🇾", "country_code": "357" },
  { "name": "Czech Republic", "flag": "🇨🇿", "country_code": "420" },
  { "name": "Denmark", "flag": "🇩🇰", "country_code": "45" },
  { "name": "Djibouti", "flag": "🇩🇯", "country_code": "253" },
  { "name": "Dominica", "flag": "🇩🇲", "country_code": "1767" },
  { "name": "Dominican Republic", "flag": "🇩🇴", "country_code": "1849" },
  { "name": "Ecuador", "flag": "🇪🇨", "country_code": "593" },
  { "name": "Egypt", "flag": "🇪🇬", "country_code": "20" },
  { "name": "El Salvador", "flag": "🇸🇻", "country_code": "503" },
  { "name": "Equatorial Guinea", "flag": "🇬🇶", "country_code": "240" },
  { "name": "Eritrea", "flag": "🇪🇷", "country_code": "291" },
  { "name": "Estonia", "flag": "🇪🇪", "country_code": "372" },
  { "name": "Ethiopia", "flag": "🇪🇹", "country_code": "251" },
  {
    "name": "Falkland Islands (Malvinas)",
    "flag": "🇫🇰",
    "country_code": "500"
  },
  { "name": "Faroe Islands", "flag": "🇫🇴", "country_code": "298" },
  { "name": "Fiji", "flag": "🇫🇯", "country_code": "679" },
  { "name": "Finland", "flag": "🇫🇮", "country_code": "358" },
  { "name": "France", "flag": "🇫🇷", "country_code": "33" },
  { "name": "French Guiana", "flag": "🇬🇫", "country_code": "594" },
  { "name": "French Polynesia", "flag": "🇵🇫", "country_code": "689" },
  {
    "name": "French Southern Territories",
    "flag": "🇹🇫",
    "country_code": "262"
  },
  { "name": "Gabon", "flag": "🇬🇦", "country_code": "241" },
  { "name": "Gambia", "flag": "🇬🇲", "country_code": "220" },
  { "name": "Georgia", "flag": "🇬🇪", "country_code": "995" },
  { "name": "Germany", "flag": "🇩🇪", "country_code": "49" },
  { "name": "Ghana", "flag": "🇬🇭", "country_code": "233" },
  { "name": "Gibraltar", "flag": "🇬🇮", "country_code": "350" },
  { "name": "Greece", "flag": "🇬🇷", "country_code": "30" },
  { "name": "Greenland", "flag": "🇬🇱", "country_code": "299" },
  { "name": "Grenada", "flag": "🇬🇩", "country_code": "1473" },
  { "name": "Guadeloupe", "flag": "🇬🇵", "country_code": "590" },
  { "name": "Guam", "flag": "🇬🇺", "country_code": "1671" },
  { "name": "Guatemala", "flag": "🇬🇹", "country_code": "502" },
  { "name": "Guernsey", "flag": "🇬🇬", "country_code": "44" },
  { "name": "Guinea", "flag": "🇬🇳", "country_code": "224" },
  { "name": "Guinea-Bissau", "flag": "🇬🇼", "country_code": "245" },
  { "name": "Guyana", "flag": "🇬🇾", "country_code": "592" },
  { "name": "Haiti", "flag": "🇭🇹", "country_code": "509" },
  {
    "name": "Heard Island and Mcdonald Islands",
    "flag": "🇭🇲",
    "country_code": "672"
  },
  {
    "name": "Holy See (Vatican City State)",
    "flag": "🇻🇦",
    "country_code": "379"
  },
  { "name": "Honduras", "flag": "🇭🇳", "country_code": "504" },
  { "name": "Hong Kong", "flag": "🇭🇰", "country_code": "852" },
  { "name": "Hungary", "flag": "🇭🇺", "country_code": "36" },
  { "name": "Iceland", "flag": "🇮🇸", "country_code": "354" },
  { "name": "India", "flag": "🇮🇳", "country_code": "91" },
  { "name": "Indonesia", "flag": "🇮🇩", "country_code": "62" },
  { "name": "Iraq", "flag": "🇮🇶", "country_code": "964" },
  { "name": "Ireland", "flag": "🇮🇪", "country_code": "353" },
  { "name": "Isle of Man", "flag": "🇮🇲", "country_code": "44" },
  { "name": "Israel", "flag": "🇮🇱", "country_code": "972" },
  { "name": "Italy", "flag": "🇮🇹", "country_code": "39" },
  { "name": "Jamaica", "flag": "🇯🇲", "country_code": "1876" },
  { "name": "Japan", "flag": "🇯🇵", "country_code": "81" },
  { "name": "Jersey", "flag": "🇯🇪", "country_code": "44" },
  { "name": "Jordan", "flag": "🇯🇴", "country_code": "962" },
  { "name": "Kazakhstan", "flag": "🇰🇿", "country_code": "7" },
  { "name": "Kenya", "flag": "🇰🇪", "country_code": "254" },
  { "name": "Kiribati", "flag": "🇰🇮", "country_code": "686" },
  {
    "name": "Korea, Republic of South Korea",
    "flag": "🇰🇷",
    "country_code": "82"
  },
  { "name": "Kosovo", "flag": "🇽🇰", "country_code": "383" },
  { "name": "Kuwait", "flag": "🇰🇼", "country_code": "965" },
  { "name": "Kyrgyzstan", "flag": "🇰🇬", "country_code": "996" },
  { "name": "Laos", "flag": "🇱🇦", "country_code": "856" },
  { "name": "Latvia", "flag": "🇱🇻", "country_code": "371" },
  { "name": "Lebanon", "flag": "🇱🇧", "country_code": "961" },
  { "name": "Lesotho", "flag": "🇱🇸", "country_code": "266" },
  { "name": "Liberia", "flag": "🇱🇷", "country_code": "231" },
  { "name": "Libyan Arab Jamahiriya", "flag": "🇱🇾", "country_code": "218" },
  { "name": "Liechtenstein", "flag": "🇱🇮", "country_code": "423" },
  { "name": "Lithuania", "flag": "🇱🇹", "country_code": "370" },
  { "name": "Luxembourg", "flag": "🇱🇺", "country_code": "352" },
  { "name": "Macao", "flag": "🇲🇴", "country_code": "853" },
  { "name": "Macedonia", "flag": "🇲🇰", "country_code": "389" },
  { "name": "Madagascar", "flag": "🇲🇬", "country_code": "261" },
  { "name": "Malawi", "flag": "🇲🇼", "country_code": "265" },
  { "name": "Malaysia", "flag": "🇲🇾", "country_code": "60" },
  { "name": "Maldives", "flag": "🇲🇻", "country_code": "960" },
  { "name": "Mali", "flag": "🇲🇱", "country_code": "223" },
  { "name": "Malta", "flag": "🇲🇹", "country_code": "356" },
  { "name": "Marshall Islands", "flag": "🇲🇭", "country_code": "692" },
  { "name": "Martinique", "flag": "🇲🇶", "country_code": "596" },
  { "name": "Mauritania", "flag": "🇲🇷", "country_code": "222" },
  { "name": "Mauritius", "flag": "🇲🇺", "country_code": "230" },
  { "name": "Mayotte", "flag": "🇾🇹", "country_code": "262" },
  { "name": "Mexico", "flag": "🇲🇽", "country_code": "52" },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "flag": "🇫🇲",
    "country_code": "691"
  },
  { "name": "Moldova", "flag": "🇲🇩", "country_code": "373" },
  { "name": "Monaco", "flag": "🇲🇨", "country_code": "377" },
  { "name": "Mongolia", "flag": "🇲🇳", "country_code": "976" },
  { "name": "Montenegro", "flag": "🇲🇪", "country_code": "382" },
  { "name": "Montserrat", "flag": "🇲🇸", "country_code": "1664" },
  { "name": "Morocco", "flag": "🇲🇦", "country_code": "212" },
  { "name": "Mozambique", "flag": "🇲🇿", "country_code": "258" },
  { "name": "Myanmar", "flag": "🇲🇲", "country_code": "95" },
  { "name": "Namibia", "flag": "🇳🇦", "country_code": "264" },
  { "name": "Nauru", "flag": "🇳🇷", "country_code": "674" },
  { "name": "Nepal", "flag": "🇳🇵", "country_code": "977" },
  { "name": "Netherlands", "flag": "🇳🇱", "country_code": "31" },
  { "name": "Netherlands Antilles", "flag": "", "country_code": "599" },
  { "name": "New Caledonia", "flag": "🇳🇨", "country_code": "687" },
  { "name": "New Zealand", "flag": "🇳🇿", "country_code": "64" },
  { "name": "Nicaragua", "flag": "🇳🇮", "country_code": "505" },
  { "name": "Niger", "flag": "🇳🇪", "country_code": "227" },
  { "name": "Nigeria", "flag": "🇳🇬", "country_code": "234" },
  { "name": "Niue", "flag": "🇳🇺", "country_code": "683" },
  { "name": "Norfolk Island", "flag": "🇳🇫", "country_code": "672" },
  { "name": "Northern Mariana Islands", "flag": "🇲🇵", "country_code": "1670" },
  { "name": "Norway", "flag": "🇳🇴", "country_code": "47" },
  { "name": "Oman", "flag": "🇴🇲", "country_code": "968" },
  { "name": "Pakistan", "flag": "🇵🇰", "country_code": "92" },
  { "name": "Palau", "flag": "🇵🇼", "country_code": "680" },
  {
    "name": "Palestinian Territory, Occupied",
    "flag": "🇵🇸",
    "country_code": "970"
  },
  { "name": "Papua New Guinea", "flag": "🇵🇬", "country_code": "675" },
  { "name": "Paraguay", "flag": "🇵🇾", "country_code": "595" },
  { "name": "Peru", "flag": "🇵🇪", "country_code": "51" },
  { "name": "Philippines", "flag": "🇵🇭", "country_code": "63" },
  { "name": "Pitcairn", "flag": "🇵🇳", "country_code": "64" },
  { "name": "Poland", "flag": "🇵🇱", "country_code": "48" },
  { "name": "Portugal", "flag": "🇵🇹", "country_code": "351" },
  { "name": "Puerto Rico", "flag": "🇵🇷", "country_code": "1939" },
  { "name": "Qatar", "flag": "🇶🇦", "country_code": "974" },
  { "name": "Romania", "flag": "🇷🇴", "country_code": "40" },
  { "name": "Rwanda", "flag": "🇷🇼", "country_code": "250" },
  { "name": "Reunion", "flag": "🇷🇪", "country_code": "262" },
  { "name": "Saint Barthelemy", "flag": "🇧🇱", "country_code": "590" },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "flag": "🇸🇭",
    "country_code": "290"
  },
  { "name": "Saint Kitts and Nevis", "flag": "🇰🇳", "country_code": "1869" },
  { "name": "Saint Lucia", "flag": "🇱🇨", "country_code": "1758" },
  { "name": "Saint Martin", "flag": "🇲🇫", "country_code": "590" },
  { "name": "Saint Pierre and Miquelon", "flag": "🇵🇲", "country_code": "508" },
  {
    "name": "Saint Vincent and the Grenadines",
    "flag": "🇻🇨",
    "country_code": "1784"
  },
  { "name": "Samoa", "flag": "🇼🇸", "country_code": "685" },
  { "name": "San Marino", "flag": "🇸🇲", "country_code": "378" },
  { "name": "Sao Tome and Principe", "flag": "🇸🇹", "country_code": "239" },
  { "name": "Saudi Arabia", "flag": "🇸🇦", "country_code": "966" },
  { "name": "Senegal", "flag": "🇸🇳", "country_code": "221" },
  { "name": "Serbia", "flag": "🇷🇸", "country_code": "381" },
  { "name": "Seychelles", "flag": "🇸🇨", "country_code": "248" },
  { "name": "Sierra Leone", "flag": "🇸🇱", "country_code": "232" },
  { "name": "Singapore", "flag": "🇸🇬", "country_code": "65" },
  { "name": "Slovakia", "flag": "🇸🇰", "country_code": "421" },
  { "name": "Slovenia", "flag": "🇸🇮", "country_code": "386" },
  { "name": "Solomon Islands", "flag": "🇸🇧", "country_code": "677" },
  { "name": "Somalia", "flag": "🇸🇴", "country_code": "252" },
  { "name": "South Africa", "flag": "🇿🇦", "country_code": "27" },
  { "name": "South Sudan", "flag": "🇸🇸", "country_code": "211" },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "flag": "🇬🇸",
    "country_code": "500"
  },
  { "name": "Spain", "flag": "🇪🇸", "country_code": "34" },
  { "name": "Sri Lanka", "flag": "🇱🇰", "country_code": "94" },
  { "name": "Sudan", "flag": "🇸🇩", "country_code": "249" },
  { "name": "Suriname", "flag": "🇸🇷", "country_code": "597" },
  { "name": "Svalbard and Jan Mayen", "flag": "🇸🇯", "country_code": "47" },
  { "name": "Swaziland", "flag": "🇸🇿", "country_code": "268" },
  { "name": "Sweden", "flag": "🇸🇪", "country_code": "46" },
  { "name": "Switzerland", "flag": "🇨🇭", "country_code": "41" },
  { "name": "Syrian Arab Republic", "flag": "🇸🇾", "country_code": "963" },
  { "name": "Taiwan", "flag": "🇹🇼", "country_code": "886" },
  { "name": "Tajikistan", "flag": "🇹🇯", "country_code": "992" },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "flag": "🇹🇿",
    "country_code": "255"
  },
  { "name": "Thailand", "flag": "🇹🇭", "country_code": "66" },
  { "name": "Timor-Leste", "flag": "🇹🇱", "country_code": "670" },
  { "name": "Togo", "flag": "🇹🇬", "country_code": "228" },
  { "name": "Tokelau", "flag": "🇹🇰", "country_code": "690" },
  { "name": "Tonga", "flag": "🇹🇴", "country_code": "676" },
  { "name": "Trinidad and Tobago", "flag": "🇹🇹", "country_code": "1868" },
  { "name": "Tunisia", "flag": "🇹🇳", "country_code": "216" },
  { "name": "Turkey", "flag": "🇹🇷", "country_code": "90" },
  { "name": "Turkmenistan", "flag": "🇹🇲", "country_code": "993" },
  { "name": "Turks and Caicos Islands", "flag": "🇹🇨", "country_code": "1649" },
  { "name": "Tuvalu", "flag": "🇹🇻", "country_code": "688" },
  { "name": "Uganda", "flag": "🇺🇬", "country_code": "256" },
  { "name": "Ukraine", "flag": "🇺🇦", "country_code": "380" },
  { "name": "United Arab Emirates", "flag": "🇦🇪", "country_code": "971" },
  { "name": "United Kingdom", "flag": "🇬🇧", "country_code": "44" },
  { "name": "Uruguay", "flag": "🇺🇾", "country_code": "598" },
  { "name": "Uzbekistan", "flag": "🇺🇿", "country_code": "998" },
  { "name": "Vanuatu", "flag": "🇻🇺", "country_code": "678" },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "flag": "🇻🇪",
    "country_code": "58"
  },
  { "name": "Vietnam", "flag": "🇻🇳", "country_code": "84" },
  { "name": "Virgin Islands, British", "flag": "🇻🇬", "country_code": "1284" },
  { "name": "Virgin Islands, U.S.", "flag": "🇻🇮", "country_code": "1340" },
  { "name": "Wallis and Futuna", "flag": "🇼🇫", "country_code": "681" },
  { "name": "Yemen", "flag": "🇾🇪", "country_code": "967" },
  { "name": "Zambia", "flag": "🇿🇲", "country_code": "260" },
  { "name": "Zimbabwe", "flag": "🇿🇼", "country_code": "263" }
]
